import { CobranzasAxios, COMPANY } from './config'

export const getReportAnualData = async (year, months) => {
  const res = await CobranzasAxios.post(`/report/anual/${COMPANY}/${year}`, { months })
  return res.data
}

export const getReportAnualStatus = async (year, months) => {
  const res = await CobranzasAxios.post(`/report/status/${COMPANY}/${year}`, { months })
  return res.data
}

export const getVoucherReportData = async (data) => {
  const res = await CobranzasAxios.post(`/report/vouchers/${COMPANY}`, data)
  return res.data
}

export const getAccountingReportData = async (data) => {
  const res = await CobranzasAxios.post(`/report/accounting/${COMPANY}`, data)
  return res.data
}

export const getMethodsReportData = async (data) => {
  const res = await CobranzasAxios.post(`/report/methods/${COMPANY}`, data)
  return res.data
}

export const getWorksReportData = async (data) => {
  const res = await CobranzasAxios.post(`/report/works/${COMPANY}`, data)
  return res.data
}

export const getGeneralReportData = async (data) => {
  const res = await CobranzasAxios.post(`/report/general/${COMPANY}`, data)
  return res.data
}

export const getCanceledReportData = async (data) => {
  const res = await CobranzasAxios.post(`/report/anulados/${COMPANY}`, data)
  return res.data
}
